// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._188f8c{font-size:.875em;min-height:1em;position:relative;color:var(--secondary);display:flex;align-items:center;white-space:nowrap;gap:.75em}._188f8c:not(:first-child){margin-top:var(--small-spacer)}[aria-roledescription=list]>._188f8c:not(:first-child){margin-top:var(--list-gutter)}._188f8c>svg{color:var(--secondary);font-size:1rem}._188f8c>button{padding:.625em 1em;font-size:.625em}._188f8c>u{content:\"\";border-top:1px solid var(--subtle);flex:1}.b14199{cursor:pointer}.ee0513{font-size:1.15em;color:var(--black);font-weight:500}.ee0513:not(:first-child){margin-top:var(--medium-spacer)}.ee0513>svg:first-child{color:inherit;margin-right:-0.25em}._288ad0{font-size:1.25em;color:var(--black);font-weight:600}", ""]);
// Exports
exports.locals = {
	"separator": "_188f8c",
	"clickable": "b14199",
	"medium": "ee0513",
	"large": "_288ad0"
};
module.exports = exports;
